import { render, staticRenderFns } from "./CustomerInformation.vue?vue&type=template&id=0b8b5713&scoped=true"
import script from "./CustomerInformation.vue?vue&type=script&lang=js"
export * from "./CustomerInformation.vue?vue&type=script&lang=js"
import style0 from "./CustomerInformation.vue?vue&type=style&index=0&id=0b8b5713&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8b5713",
  null
  
)

export default component.exports